const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5000/api";

export async function apiLogin(email: string, password: string) {
  const res = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Login failed");
  return data as { token: string; user: { id: string; name: string; email: string; roleName: string; username?: string } };
}

export async function apiSignup(payload: {
  name: string;
  email: string;
  password: string;
}) {
  const res = await fetch(`${BASE}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Signup failed");
  return data as { message: string; user: { id: string; name: string; email: string } };
}

export async function apiGetMe(token: string) {
  const res = await fetch(`${BASE}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (res.status === 401) throw Object.assign(new Error("Unauthorized"), { status: 401 });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Failed to fetch user");
  return data as { name: string; email: string; role: string };
}

export async function apiGetUserTeams(token: string) {
  const res = await fetch(`${BASE}/users/teams`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  console.log('Fetched teams:', data);
  if (!res.ok) throw new Error(data.message ?? "Failed to fetch teams");
  return data as { teams: Array<{
    id: string;
    name: string;
    hackathon: string;
    hackathonId: string;
    maxTeamSize: number;
    status: 'Selected' | 'Under Review' | 'Registered' | 'Rejected';
    leader: { name: string; email: string; avatar: string };
    members: { name: string; email?: string; grade?: string; jobRole?: string; avatar: string }[];
  }> };
}

export async function apiUpdateTeamMembers(
  token: string,
  teamId: string,
  members: Array<{ name: string; email: string; grade: string; jobRole: string; status?: string; userId?: string }>
) {
  const res = await fetch(`${BASE}/users/teams/${teamId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ members }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Failed to update team members");
  return data;
}
